// Vendor scripts
import 'bootstrap'

// Vue
import './vue/vue.js'

// Custom scripts
import './scripts/accordion-anchors'
import './scripts/accordion-search'
import './scripts/alert'
import './scripts/anchor'
import './scripts/collapse-prevent-close'
import './scripts/header'
import './scripts/image-caption-toggle'
import './scripts/image-modal'
import './scripts/see-more'
import './scripts/speedBump'
import './scripts/swiper-config'
import './scripts/video-modal'


// Export libraries for global use
import * as FullCalendar from 'fullcalendar'
window.FullCalendar = FullCalendar